import React, { useRef, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Link,
  useLocation,
  useHistory,
} from "react-router-dom";
import {
  FormControlLabel,
  TextField,
  RadioGroup,
  Radio,
  FormLabel,
  FormControl,
} from "@material-ui/core";
import agentIcon from "../../assets/img/agent.svg";
import customerIcon from "../../assets/img/customer.svg";
import claim from "../../assets/img/claim.svg";
import lien from "../../assets/img/lien.svg";
import makePayment from "../../assets/img/make_payment.svg";
import arrowLeft from "../../assets/img/arrow-left.png";
import arrowRight from "../../assets/img/arrow-right.png";
import cardImage from "../../assets/img/card.png";
import Axios from "axios";
import GA from "../functions/GA";
import selectCorrectUrls from "../../selectCorrectUrls";
import { useDispatch, useSelector } from "react-redux";
import "./QuickServices.css";
import layout from "../../assets/img/login.png";
import { eventBus } from "../../eventBus";

const quickServices = [
  { label: "Agents", icon: agentIcon },
  { label: "Policyholder", icon: customerIcon },
  { label: "Claim Support", icon: claim },
  { label: "Become an Agent", icon: agentIcon },
  { label: "Lienholder Search", icon: lien },
  { label: "Make a Payment", icon: makePayment },
];

const cardStyle = {
  backgroundImage: `url(${cardImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  borderRadius: "12px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  padding: "24px 16px",
  minWidth: "225px",
  maxWidth: "225px",
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  cursor: "pointer",
};
const cardStyle_m = {
  backgroundImage: `url(${cardImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  borderRadius: "12px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  padding: "9px 16px",
  minWidth: "180px",
  maxWidth: "225px",
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  cursor: "pointer",
};

const loginButtonStyle = {
  background: "#fff",
  color: "#01224F",
  border: "1.2px solid #0E72D6",
  borderRadius: "5px",
  padding: "8px 18px",
  marginTop: "10px",
  cursor: "pointer",
  width: "170px",
  fontSize: "15px",
  fontWeight: 500,
};
const loginButtonStyle_m = {
  background: "#fff",
  color: "#01224F",
  border: "1.2px solid #0E72D6",
  borderRadius: "5px",
  padding: "8px 18px",
  marginTop: "10px",
  cursor: "pointer",
  width: "145px",
  fontSize: "12px",
  fontWeight: 500,
};

const bottomArrowContainerStyle = {
  display: "flex",
  justifyContent: "left",
  gap: "20px",
  marginTop: "10px",
};

const arrowButtonStyle = {
  cursor: "pointer",
  width: "35px",
  height: "35px",
};
const arrowButtonStyle_m = {
  cursor: "pointer",
  width: "20px",
  height: "20px",
};

export default function QuickServicesCarousel({ responsiveStatus }) {
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        setShowModal(false);
        setShowSecondModal(false);
        // Do something (e.g., close modal)
      }
    };

    document.addEventListener("keydown", handleEsc);

    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);

  const scrollRef = useRef(null);
  const history = useHistory();
  const [errors, setErrors] = useState({ username: false, password: false });

  useEffect(() => {
    const el = scrollRef.current;
    let isDown = false;
    let startX;
    let scrollLeft;

    const onMouseDown = (e) => {
      isDown = true;
      el.classList.add("active");
      startX = e.pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
    };

    const onMouseLeave = () => {
      isDown = false;
      el.classList.remove("active");
    };

    const onMouseUp = () => {
      isDown = false;
      el.classList.remove("active");
    };

    const onMouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - el.offsetLeft;
      const walk = (x - startX) * 1.5; // speed
      el.scrollLeft = scrollLeft - walk;
    };

    el.addEventListener("mousedown", onMouseDown);
    el.addEventListener("mouseleave", onMouseLeave);
    el.addEventListener("mouseup", onMouseUp);
    el.addEventListener("mousemove", onMouseMove);

    return () => {
      el.removeEventListener("mousedown", onMouseDown);
      el.removeEventListener("mouseleave", onMouseLeave);
      el.removeEventListener("mouseup", onMouseUp);
      el.removeEventListener("mousemove", onMouseMove);
    };
  }, []);

  const dispatch = useDispatch();
  const [forgotPasswordAgent, setForgotPasswordAgent] = useState("");
  const [forgotPasswordCustomer, setForgotPasswordCustomer] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showSecondModal, setShowSecondModal] = useState(false);
  const [activeTab, setActiveTab] = useState("agent");
  const [selectedRole, setSelectedRole] = useState("agent");
  const [isLoading, setIsLoading] = useState(false);
  const [agentUsername, setAgentUserName] = useState("");
  const [agentPassword, setAgentPassword] = useState("");
  const [customerUsername, setCustomerUsername] = useState("");
  const [customerPassword, setCustomerPassword] = useState("");
  const [isAgentDisabled, setAgentDisabled] = useState(true);
  const [isCustomerDisabled, setCustomerDisabled] = useState(true);
  const isRequestHelpOpen = useSelector((state) => state.requestHelpReducer);
  const [weather_message_html, set_weather_message_html] =
    useState(`<p>Hello there</p>`);
  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const [windowWidth, setWindowWidth] = useState();
  const [windowScrollPosition, setWindowScrollPosition] = useState(0);
  const [agentActionUrl, setAgentActionUrl] = useState("");
  const [isForgotPasswordTimerAgent, setIsForgotPasswordTimerAgent] =
    useState(false);
  const [forgotPasswordTimerSecondsAgent, setForgotPasswordTimerSecondsAgent] =
    useState(120);
  const [isForgotPasswordTimerCustomer, setIsForgotPasswordTimerCustomer] =
    useState(false);
  const [
    forgotPasswordTimerSecondsCustomer,
    setForgotPasswordTimerSecondsCustomer,
  ] = useState(120);
  const [isMessage, setIsMessage] = useState(false);
  const [isErrorMessage, setIsErrorMessage] = useState(false);
  const [message, setMessage] = useState("");
  const [isForgotPasswordAgent, setIsForgotPasswordAgent] = useState(false);
  const [isForgotPasswordCustomer, setIsForgotPasswordCustomer] =
    useState(false);
  const [isconfirmLoginMessage, setIsConfirmLoginMessage] = useState(false);
  const [correctNamesAndIds, setCorrectNamesAndIds] = useState({
    username: "",
    password: "",
    nameUserId: "",
    namePassword: "",
  });
  const [correctNamesAndIdsCustomer, setCorrectNamesAndIdsCustomer] = useState({
    username: "",
    password: "",
    nameUserId: "",
    namePassword: "",
  });
  const [config, setConfig] = useState({
    headers: {
      "Content-Type": "text/html",
    },
    responseType: "text",
  });

  const [startIndex, setStartIndex] = useState(0);
  const [ITEMS_PER_PAGE, setItemsPerPage] = useState(2);
  // const [responsiveStatus, setResponsiveStatus] = useState(false);
  // const ITEMS_PER_PAGE = 4;

  useEffect(() => {
    if (responsiveStatus === "isDesktop") {
      setItemsPerPage(3);
    } else if (
      responsiveStatus === "isTablet" ||
      responsiveStatus === "isTabletLandscape"
    ) {
      setItemsPerPage(3);
    } else {
      setItemsPerPage(2);
    }
  }, [responsiveStatus]);

  const getInputClass = (value, error) => {
    if (error) return "form-control border-danger";
    if (value.trim() !== "") return "form-control border-success";
    return "form-control";
  };

  //login for the agent portal
  const agentValidPost = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const newErrors = {
      username: agentUsername.trim() === "",
      password: agentPassword.trim() === "",
    };
    setErrors(newErrors);
    if (!newErrors.username && !newErrors.password) {
      let url = `${
        selectCorrectUrls().insuredPortal
      }/uaicins/agent/login/validate?tbxUserID=${agentUsername}&tbxPassword=${encodeURIComponent(
        agentPassword
      )}`;

      let urlWeather =
        "https://www.uaig.net/uaichome/static/msgs/fl_message.html";

      Axios.get(url, config)
        .then((response) => {
          setAgentActionUrl(response.data.url);

          if (
            response.data.url ===
              `${
                selectCorrectUrls().florida
              }/agents/ndmacro/cmn_Login.mac/CheckLogin` ||
            response.data.url ===
              `${
                selectCorrectUrls().georgia
              }/agents/ndmacro/cmn_Login.mac/CheckLogin`
          ) {
            setCorrectNamesAndIds({
              id: "tbxUserID",
              password: "tbxPassword",
              nameUserId: "tbxUserID",
              namePassword: "tbxPassword",
            });

            urlWeather =
              "https://www.uaig.net/uaichome/static/msgs/fl_message.html";
          } else if (
            response.data.url ===
            `${selectCorrectUrls().texas}/agents/cgi-dta/ilogin.mac/CheckLogin`
          ) {
            setCorrectNamesAndIds({
              id: "tbxUserID",
              password: "tbxPassword",
              nameUserId: "tbxUserID",
              namePassword: "tbxPassword",
            });

            urlWeather =
              "https://www.uaig.net/uaichome/static/msgs/tx_message.html";
          }

          Axios.post(urlWeather)
            .then((response_weather) => {
              setIsLoading(false);

              set_weather_message_html(response_weather.data);
              if (response.data.status === 1) {
                if (response_weather.data !== ".") {
                  setIsConfirmLoginMessage(true);
                } else {
                  GA(
                    "AGENT_LOGIN_SUCCESSFUL",
                    `${agentUsername} - Succesfully logged into Agent Portal`
                  );

                  setIsMessage(true);
                  setMessage(response.data.msg);
                  document.getElementById("mainFormAgent").submit();
                }
              } else {
                e.preventDefault();

                GA(
                  "AGENT_LOGIN_FAILED",
                  `${agentUsername} - Agent failed to logged into Agent Portal`
                );

                setIsErrorMessage(true);
                setMessage(response.data.msg);
              }
            })
            .catch((e_weather) => {
              setIsLoading(false);

              if (response.data.status === 1) {
                setIsMessage(true);
                setMessage(response.data.msg);

                setTimeout(() => {
                  //document.getElementById("mainFormAgent").submit();
                }, 1000);
              } else {
                e.preventDefault();

                setIsErrorMessage(true);
                setMessage(response.data.msg);
              }
            });
        })
        .catch((e) => {
          setIsLoading(false);

          //set a custom error message in the div  : System Failure: Please try after some time.

          GA(
            "AGENT_SYSTEM_FAILURE",
            `${customerUsername} -  System failure while trying to log into the Aent Portatl`
          );

          setIsErrorMessage(true);
          setMessage("System Failure: Please try after some time.");

          // console.log(e);
        });
    }
  };

  const customerValidPost = (e) => {
    e.preventDefault();
    setIsLoading(true);

    let url = `${
      selectCorrectUrls().insuredPortal
    }/insurednew/insured/logincheck/customer?username=${customerUsername}&password=${encodeURIComponent(
      customerPassword
    )}`;

    Axios.get(url, config)
      .then((response) => {
        setIsLoading(false);
        let data = response.data.replace(/^\s+|\s+$/g, "");
        // console.log(response);
        if (data === "OK") {
          GA(
            "CUSTOMER_LOGIN_SUCCESSFUL",
            `${customerUsername} - Successfully logged in Insured Portal`
          );

          setIsMessage(true);
          setMessage("You have Successfully Logged In");
          document.getElementById("mainFormCustomer").submit();
          return true;
        } else {
          GA(
            "CUSTOMER_LOGIN_FAILED",
            `${customerUsername} -  Failed while trying to log into the Insured Portal`
          );

          setIsErrorMessage(true);
          setMessage(data);
          return false;
        }
      })
      .catch((e) => {
        setIsLoading(false);
        GA(
          "CUSTOMER_SYSTEM_FAILURE",
          `${customerUsername} -  System failure while trying to log into the Insured Portatl`
        );

        setIsErrorMessage(true);
        setMessage("System Failure: Please try after some time.");

        // console.log(e);
      });
  };

  const sendForgotPasswordEmail = (e, where) => {
    e.preventDefault();
    setIsLoading(true);

    setIsForgotPasswordAgent(false);
    setIsForgotPasswordCustomer(false);

    //this is a test url, once we have the correct service we can send emails to the email that the user typed

    let url = "";

    if (where === "agent") {
      url = `${
        selectCorrectUrls().insuredPortal
      }/uaicins/agent/forgotpassword/index?agentid=${forgotPasswordAgent}`;

      Axios.get(url, config)
        .then((response) => {
          setIsLoading(false);

          if (response.data.status == 1) {
            setIsMessage(true);

            setMessage(
              "If a valid email is found we would be sending instructions to reset password in the email."
            );
            GA(
              "FORGOT_PASSWORD_AGENT",
              `${forgotPasswordAgent} - Successfully requested to change password`
            );

            setForgotPasswordTimerSecondsAgent(120);
            setIsForgotPasswordTimerAgent(true);
          } else if (response.data.status == 0) {
            GA(
              "FORGOT_PASSWORD_AGENT_FAILED",
              `${forgotPasswordAgent} - Failed to request to change password`
            );

            setIsErrorMessage(true);
            setMessage(response.data.msg);
          }
        })
        .catch((e) => {
          setIsLoading(false);

          // console.log(e);
          setIsForgotPasswordAgent(false);
          setIsForgotPasswordCustomer(false);
          setIsErrorMessage(true);
          setMessage("Something went wrong, try again later.");
        });
    } else if (where === "customer") {
      url = `${
        selectCorrectUrls().insuredPortal
      }/insurednew/insured/pms/fp?email-id=${forgotPasswordCustomer}`;

      Axios.get(url)
        .then((response) => {
          setIsLoading(true);

          // console.log(response);

          setIsForgotPasswordAgent(false);
          setIsForgotPasswordCustomer(false);

          if (response.data.status == 1) {
            setIsMessage(true);
            setMessage(
              "If a valid email is found we would be sending instructions to reset password in the email."
            );
            GA(
              "FORGOT_PASSWORD_CUSTOMER",
              `${forgotPasswordCustomer} - Successfully requested to change password`
            );

            setForgotPasswordTimerSecondsAgent(120);
            setIsForgotPasswordTimerAgent(true);
          } else if (response.data.status == 0) {
            GA(
              "FORGOT_PASSWORD_CUSTOMER_FAILED",
              `${forgotPasswordCustomer} - Failed to request to change password`
            );

            setIsMessage(true);
            setMessage(response.data.displaymsg);
            setForgotPasswordTimerSecondsCustomer(120);
            setIsForgotPasswordTimerCustomer(true);
          }
        })
        .catch((e) => {
          setIsLoading(false);

          // console.log(e);
          setIsForgotPasswordAgent(false);
          setIsForgotPasswordCustomer(false);
          setIsErrorMessage(true);
          setMessage("Something went wrong, try again later.");
        });
    }
  };

  const handlePrev = () => {
    setStartIndex((prev) => Math.max(prev - ITEMS_PER_PAGE, 0));
  };

  const handleNext = () => {
    setStartIndex((prev) =>
      Math.min(
        prev + ITEMS_PER_PAGE,
        quickServices.length - (ITEMS_PER_PAGE - 1)
      )
    );
  };

  const visibleServices = quickServices.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE
  );

  const checkDisabledButtonAgent = () => {
    if (isAgentDisabled) {
      return "home-page-button-off";
    } else return "home-page-button";
  };

  const checkDisabledButtonCustomer = () => {
    if (isCustomerDisabled) {
      return "home-page-button-off";
    } else return "home-page-button";
  };

  const handleChange = (event) => {
    setSelectedRole(event.target.value);
  };

  const toggleStyle = (type) => ({
    flex: 1,
    padding: "10px 20px",
    textAlign: "center",
    fontSize: "13px",
    fontWeight:
      type === "agent" && activeTab === "agent"
        ? 500
        : type === "customer" && activeTab === "customer"
        ? 500
        : "normal",
    color: "#007bff",
    backgroundColor: "transparent",
    border: "1px solid #007bff",
    borderRadius: "6px",
    transition: "all 0.2s ease-in-out",
  });

  const forgotPasswordComponentAgent = () => {
    return (
      <div>
        <div
          onClick={() => {
            setIsForgotPasswordCustomer(false);
            setIsForgotPasswordAgent(false);
          }}
          className={
            isForgotPasswordAgent
              ? "forgot-password-background-on"
              : "forgot-password-background-off"
          }
        ></div>
        <div
          className={
            isForgotPasswordAgent
              ? "forgot-password-component-shown"
              : "forgot-password-component-hidden"
          }
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h3>Forgot your password?</h3>
            <h2
              className="close-login-menu-icon"
              onClick={() => {
                setIsForgotPasswordCustomer(false);
                setIsForgotPasswordAgent(false);
              }}
            >
              <i
                className="fa fa-times-circle"
                style={{ fontSize: "1em", color: "#01224f" }}
                aria-hidden="true"
              ></i>
              &nbsp;
            </h2>
          </div>

          <hr></hr>
          <form
            onSubmit={(e) => {
              sendForgotPasswordEmail(e, "agent");
            }}
          >
            <div style={{ marginTop: "1rem" }}>
              <h4>Enter your Username:</h4>
              <TextField
                placeholder="Username"
                label="Username"
                variant="outlined"
                autoFocus
                required
                fullWidth
                value={forgotPasswordAgent}
                onChange={(e) => {
                  setForgotPasswordAgent(e.target.value);
                }}
                style={{ marginTop: "12px" }}
              />
              {/* <input
                type="text"
                maxLength="20"
                required
                placeholder="EX: jondoe123"
                value={forgotPasswordAgent}
                onChange={(e) => {
                  setForgotPasswordAgent(e.target.value);
                }}
              ></input> */}
            </div>
            <button
              disabled={isForgotPasswordTimerAgent}
              type="submit"
              style={
                isForgotPasswordTimerAgent
                  ? {
                      backgroundColor: "rgba(220,220,220)",
                      marginTop: "10px",
                      cursor: "default",
                      pointerEvents: "none",
                      color: "black",
                    }
                  : { marginTop: "10px" }
              }
              className="home-page-button"
            >
              {isForgotPasswordTimerAgent
                ? forgotPasswordTimerSecondsAgent
                : "Submit"}
            </button>
          </form>
        </div>
      </div>
    );
  };

  const forgotPasswordComponentCustomer = () => {
    return (
      <div>
        <div
          onClick={() => {
            setIsForgotPasswordAgent(false);
            setIsForgotPasswordCustomer(false);
          }}
          className={
            isForgotPasswordCustomer
              ? "forgot-password-background-on"
              : "forgot-password-background-off"
          }
        ></div>
        <div
          className={
            isForgotPasswordCustomer
              ? "forgot-password-component-shown"
              : "forgot-password-component-hidden"
          }
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h2>Forgot your password?</h2>
            <h2
              className="close-login-menu-icon"
              onClick={() => {
                setIsForgotPasswordCustomer(false);
                setIsForgotPasswordAgent(false);
              }}
            >
              <i
                className="fa fa-times-circle"
                style={{ fontSize: "1.5em", color: "#01224f" }}
                aria-hidden="true"
              ></i>{" "}
              &nbsp;
            </h2>
          </div>

          <hr></hr>
          <form
            onSubmit={(e) => {
              sendForgotPasswordEmail(e, "customer");
            }}
          >
            <div style={{ marginTop: "1rem" }}>
              <TextField
                placeholder="Email"
                label="Enter your Email"
                variant="outlined"
                autoFocus
                required
                fullWidth
                value={forgotPasswordCustomer}
                onChange={(e) => {
                  setForgotPasswordCustomer(e.target.value);
                }}
                style={{ marginTop: "12px" }}
              />
            </div>
            <button
              disabled={isForgotPasswordTimerCustomer}
              type="submit"
              style={
                isForgotPasswordTimerCustomer
                  ? {
                      backgroundColor: "rgba(220,220,220)",
                      marginTop: "10px",
                      cursor: "default",
                      pointerEvents: "none",
                      color: "black",
                    }
                  : { marginTop: "10px" }
              }
              className="home-page-button"
            >
              {isForgotPasswordTimerCustomer
                ? forgotPasswordTimerSecondsCustomer
                : "Submit"}
            </button>
          </form>
        </div>
      </div>
    );
  };

  return (
    <>
      <div
        style={{
          backgroundImage: `url(${require("../../assets/img/quick_service_layout.png")})`,
          backgroundSize: "cover",
          padding: "60px 20px",
          height:
            responsiveStatus === "isDesktop"
              ? "475px"
              : responsiveStatus === "isTablet" ||
                responsiveStatus === "isTabletLandscape"
              ? "475px"
              : "400px",
          marginTop: "0px",
        }}
        className="quick-service-container"
      >
        <div
          style={{
            width: "100%",
            maxWidth: "1350px",
            margin:
              responsiveStatus === "isDesktop"
                ? "0"
                : responsiveStatus === "isTablet" ||
                  responsiveStatus === "isTabletLandscape"
                ? "0 auto"
                : "0 auto",
            display: "flex",
            gap: "40px",
            flexWrap: "wrap",
          }}
        >
          {/* LEFT SECTION */}
          <div
            style={{
              margin: "0 auto",
              maxWidth:
                responsiveStatus === "isTabletLandscape" ? "300px" : "1115px",
              display:
                responsiveStatus === "isDesktop" ||
                responsiveStatus === "isTabletLandscape"
                  ? "flex"
                  : responsiveStatus === "isTablet"
                  ? "block"
                  : "block",
              flexDirection: "row",
              marginLeft:
                responsiveStatus === "isDesktop"
                  ? "13%"
                  : responsiveStatus === "isTablet" ||
                    responsiveStatus === "isTabletLandscape"
                  ? "4em"
                  : "inherit",
            }}
            className="left_section"
          >
            <div className="col-md-4 col-12">
              <div
                style={{
                  flex: "1",
                  minWidth: "200px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "flex-start",
                }}
              >
                <p
                  style={{
                    color: "#000000",
                    fontSize:
                      responsiveStatus === "isDesktop"
                        ? "18px"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "18px"
                        : "18px",
                    lineHeight: "1.2",
                    fontWeight:
                      responsiveStatus === "isDesktop"
                        ? 500
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? 500
                        : 600,
                    whiteSpace: "nowrap",
                  }}
                >
                  <span className="blue-underline">For your con</span>
                  venience
                </p>

                <h1
                  style={{
                    color: "#01224F",
                    lineHeight: "1.2",
                    fontWeight: "bold",
                    marginTop: "0.5em",
                    fontSize:
                      responsiveStatus === "isDesktop"
                        ? "36px"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "36px"
                        : "30px",
                  }}
                >
                  Quick Services
                </h1>
              </div>
            </div>
            <div className="col-12 col-md-8">
              {/* RIGHT SECTION */}
              <div
                ref={scrollRef}
                className="rightSection"
                style={{
                  display: "flex",
                  gap: "20px",
                  justifyContent: "flex-start",
                  marginBottom: "30px",
                  flexDirection: "row",
                  overflowX: "auto",
                  flexWrap: "nowrap",
                  // cursor: "grab", // indicates it's draggable
                  WebkitOverflowScrolling: "touch",
                  minWidth:
                    responsiveStatus === "isDesktop"
                      ? "inherit"
                      : responsiveStatus === "isTablet" ||
                        responsiveStatus === "isTabletLandscape"
                      ? "inherit"
                      : "inherit",
                }}
              >
                {visibleServices.map((service, index) => (
                  <div
                    key={index}
                    style={
                      responsiveStatus === "isDesktop"
                        ? cardStyle
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? cardStyle
                        : cardStyle_m
                    }
                    onClick={() => {
                      if (service.label === "Agents") {
                        // setShowModal(true);
                        dispatch({
                          type: "SET_LOGIN_PAGE_TO_DISPLAY",
                          payload: "AGENT",
                        });
                        setActiveTab("agent");

                        setTimeout(() => {
                          eventBus.publish("openModal");
                        }, 0);
                      } else if (service.label === "Policyholder") {
                        dispatch({
                          type: "SET_LOGIN_PAGE_TO_DISPLAY",
                          payload: "CUSTOMER",
                        });
                        setActiveTab("customer");

                        setTimeout(() => {
                          eventBus.publish("openModal");
                        }, 0);
                      } else if (service.label === "Claim Support") {
                        history.push("/uaichome/claims");
                      } else if (service.label === "Become an Agent") {
                        history.push("/uaichome/FindAnAgent");
                      } else if (service.label === "Lienholder Search") {
                        history.push("/uaichome/leinholder");
                      } else if (service.label === "Make a Payment") {
                        window.open(
                          "https://mypolicy.uaig.net/insurednew/",
                          "_self"
                        );
                      }
                    }}
                  >
                    <div>
                      <img
                        src={service.icon}
                        alt={service.label}
                        style={{ width: "60px", marginBottom: "15px" }}
                      />
                      <div
                        style={{
                          fontWeight: "bold",
                          fontSize:
                            responsiveStatus === "isDesktop"
                              ? "15px"
                              : responsiveStatus === "isTablet" ||
                                responsiveStatus === "isTabletLandscape"
                              ? "15px"
                              : "12px",
                          marginBottom:
                            responsiveStatus === "isDesktop"
                              ? "10px"
                              : responsiveStatus === "isTablet" ||
                                responsiveStatus === "isTabletLandscape"
                              ? "10px"
                              : "2px",
                        }}
                      >
                        {service.label}
                      </div>
                      {service.label === "Agents" && (
                        <button
                          style={
                            responsiveStatus === "isDesktop"
                              ? loginButtonStyle
                              : responsiveStatus === "isTablet" ||
                                responsiveStatus === "isTabletLandscape"
                              ? loginButtonStyle
                              : loginButtonStyle_m
                          }
                          onClick={() => {
                            eventBus.publish("openModal");
                            setActiveTab("agent");
                            dispatch({
                              type: "SET_LOGIN_PAGE_TO_DISPLAY",
                              payload: "AGENT",
                            });
                          }}
                        >
                          Login
                        </button>
                      )}
                      {service.label === "Policyholder" && (
                        <button
                          style={
                            responsiveStatus === "isDesktop"
                              ? loginButtonStyle
                              : responsiveStatus === "isTablet" ||
                                responsiveStatus === "isTabletLandscape"
                              ? loginButtonStyle
                              : loginButtonStyle_m
                          }
                          onClick={() => {
                            setActiveTab("customer");
                            dispatch({
                              type: "SET_LOGIN_PAGE_TO_DISPLAY",
                              payload: "CUSTOMER",
                            });
                            eventBus.publish("openModal");
                          }}
                        >
                          Login
                        </button>
                      )}
                      {service.label === "Claim Support" && (
                        <Link
                          style={{
                            textDecoration: "none",
                          }}
                          to="/uaichome/claims"
                          onClick={() => {
                            GA(
                              "File_A_Claim",
                              "User clicked on the File a Claim Card"
                            );
                          }}
                        >
                          <button
                            style={
                              responsiveStatus === "isDesktop"
                                ? loginButtonStyle
                                : responsiveStatus === "isTablet" ||
                                  responsiveStatus === "isTabletLandscape"
                                ? loginButtonStyle
                                : loginButtonStyle_m
                            }
                          >
                            Login
                          </button>
                        </Link>
                      )}
                      {service.label === "Become an Agent" && (
                        <Link
                          style={{
                            textDecoration: "none",
                          }}
                          to="/uaichome/FindAnAgent"
                          onClick={() => {
                            GA(
                              "File_A_Claim",
                              "User clicked on the File a Claim Card"
                            );
                          }}
                        >
                          <button
                            style={
                              responsiveStatus === "isDesktop"
                                ? loginButtonStyle
                                : responsiveStatus === "isTablet" ||
                                  responsiveStatus === "isTabletLandscape"
                                ? loginButtonStyle
                                : loginButtonStyle_m
                            }
                          >
                            Start Now
                          </button>
                        </Link>
                      )}
                      {service.label === "Lienholder Search" && (
                        <Link
                          style={{
                            textDecoration: "none",
                          }}
                          to="/uaichome/leinholder"
                          onClick={() => {
                            GA(
                              "File_A_Claim",
                              "User clicked on the File a Claim Card"
                            );
                          }}
                        >
                          <button
                            style={
                              responsiveStatus === "isDesktop"
                                ? loginButtonStyle
                                : responsiveStatus === "isTablet" ||
                                  responsiveStatus === "isTabletLandscape"
                                ? loginButtonStyle
                                : loginButtonStyle_m
                            }
                          >
                            Search
                          </button>
                        </Link>
                      )}
                      {service.label === "Make a Payment" && (
                        <a
                          onClick={() => {
                            GA(
                              "Make a subro payment",
                              "User Clicked on Make a subro Payment"
                            );
                          }}
                          style={{
                            textDecoration: "none",
                          }}
                          href={`https://mypolicy.uaig.net/insurednew/`}
                        >
                          <button
                            style={
                              responsiveStatus === "isDesktop"
                                ? loginButtonStyle
                                : responsiveStatus === "isTablet" ||
                                  responsiveStatus === "isTabletLandscape"
                                ? loginButtonStyle
                                : loginButtonStyle_m
                            }
                          >
                            Pay Now
                          </button>
                        </a>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <div style={bottomArrowContainerStyle}>
                <img
                  style={
                    responsiveStatus === "isDesktop"
                      ? arrowButtonStyle
                      : responsiveStatus === "isTablet" ||
                        responsiveStatus === "isTabletLandscape"
                      ? arrowButtonStyle
                      : arrowButtonStyle_m
                  }
                  onClick={handlePrev}
                  disabled={startIndex === 0}
                  src={arrowLeft}
                  className="arrows"
                  alt="arrows"
                />
                {startIndex + ITEMS_PER_PAGE <= quickServices.length && (
                  <img
                    style={
                      responsiveStatus === "isDesktop"
                        ? arrowButtonStyle
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? arrowButtonStyle
                        : arrowButtonStyle_m
                    }
                    onClick={handleNext}
                    disabled={
                      startIndex + ITEMS_PER_PAGE <= quickServices.length
                    }
                    src={arrowRight}
                    alt="arrowRight"
                    className="arrows"
                  />
                )}
                {!(startIndex + ITEMS_PER_PAGE <= quickServices.length) && (
                  <img
                    style={
                      responsiveStatus === "isDesktop"
                        ? arrowButtonStyle
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? arrowButtonStyle
                        : arrowButtonStyle_m
                    }
                    disabled={
                      startIndex + ITEMS_PER_PAGE <= quickServices.length
                    }
                    src={arrowRight}
                    alt="arrowRight"
                    className="arrows"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {(responsiveStatus === "isMobile" ||
        responsiveStatus === "isSmallMobile") &&
        showModal && (
          <div className="modal show fade d-block" tabIndex="-1" role="dialog">
            {/* <div className="modal-dialog modal-dialog-centered" role="document"> */}
            <div className="modal-content">
              <div className="modal-body custom-m odal-width">
                <div className="modal show d-block" tabIndex="-1" role="dialog">
                  <div
                    className="modal-dialog modal-xl modal-dialog-centered"
                    role="document"
                  >
                    <div
                      style={
                        responsiveStatus ? styles.container1 : styles.container
                      }
                      className="modal-content d-flex flex-row"
                    >
                      {/* Left Panel */}
                      <div className="p-4 d-flex flex-column align-items-center justify-content-center w-50">
                        {/* <h2 className="fw-bold">Welcome<br />Back!</h2>
                <img 
                  src={require('../../assets/img/logo.png')}
                  alt="Welcome"
                  className="img-fluid mt-3"
                  style={{ maxHeight: '250px' }}
                /> */}
                      </div>
                      {/* Trigger Button */}
                      <div className="d-flex justify-content-center mt-3"></div>
                      {/* Right Panel */}
                      <div className="p-4 w-50 position-relative">
                        <button
                          type="button"
                          className="btn-close position-absolute end-0 top-0 m-3"
                          onClick={() => setShowModal(false)}
                          aria-label="Close"
                        ></button>

                        {/* Logo */}
                        <div className="text-center mb-3">
                          <img
                            src={require("../../assets/img/logo.png")}
                            alt="Car and Woman"
                            className="img-fluid"
                            style={{ height: "40px" }}
                          />
                          <br />
                          <small className="text-muted">
                            Automobile Insurance Company
                          </small>
                        </div>

                        {/* Tabs */}
                        <div
                          style={{
                            display: "flex",
                            border: "1px solid #ddd",
                            backgroundColor: "#f8f9fa",
                            borderRadius: "8px",
                            width: "100%",
                            overflow: "hidden",
                            padding: "4px",
                            marginBottom: "10px",
                          }}
                        >
                          <div style={toggleStyle("agent")}>Agent Login</div>
                        </div>
                        <form>
                          {" "}
                          <div className="mb-3">
                            <input
                              style={{ fontSize: "14px", color: "#A39B9B" }}
                              type="text"
                              value={agentUsername}
                              onChange={(e) => {
                                setAgentUserName(e.target.value);
                              }}
                              className="form-control"
                              placeholder="Username"
                            />
                          </div>
                          <div className="mb-3">
                            <input
                              style={{ fontSize: "14px", color: "#A39B9B" }}
                              type="password"
                              value={agentPassword}
                              onChange={(e) => {
                                setAgentPassword(e.target.value);
                              }}
                              className="form-control"
                              placeholder="Password"
                            />
                          </div>
                          <button
                            style={{
                              width: "100%",
                              backgroundColor: "#0E72D6",
                            }}
                            onClick={(e) => {
                              agentValidPost(e);
                              GA(
                                "Log_In ",
                                "User clicked on the agents login button inside pop up"
                              );
                            }}
                            className={checkDisabledButtonAgent(
                              isAgentDisabled
                            )}
                            type="submit"
                          >
                            Login
                          </button>
                          <div
                            className="text-center mt-3"
                            style={{ fontSize: "14px" }}
                          >
                            <a
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setIsForgotPasswordAgent(true);
                                GA(
                                  "FORGOT_PASSWORD_AGENT_D",
                                  "User clicked on the FORGOT_PASSWORD_AGENT on popup "
                                );
                              }}
                              className="text-primary text-decoration-none"
                            >
                              Reset Password
                            </a>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* </div> */}
            </div>
            {/* Modal backdrop */}
            <div className="modal-backdrop fade show"></div>
          </div>
        )}
      {responsiveStatus !== "isMobile" &&
        responsiveStatus !== "isSmallMobile" &&
        showModal && (
          <div
            className={`modal show fade d-block ${
              isForgotPasswordCustomer ? "modal-blur" : ""
            }`}
            tabIndex="-1"
            role="dialog"
          >
            <div
              className="modal-dialog modal-dialog-mobile-centered"
              role="document"
            >
              <div className="modal show d-block" tabIndex="-1" role="dialog">
                <div
                  className="modal-dialog modal-xl modal-dialog-mobile-centered"
                  role="document"
                >
                  <div
                    className="modal-content d-flex flex-column"
                    style={{
                      width: "auto",
                      maxHeight: "100vh",
                      overflowY: "auto",
                      position: "relative",
                    }}
                  >
                    {/* Left Panel */}
                    <div
                      style={{
                        position: "relative",
                        width: "100",
                        height: "150px",
                      }}
                    >
                      <img
                        src={require("../../assets/img/responsive_icon/popup_layout1.svg")}
                        alt="Background"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                      <img
                        src={require("../../assets/img/responsive_icon/circles.svg")}
                        alt="Overlay"
                        style={{
                          position: "absolute",
                          top: "10px",
                          left: "10px",
                          width: "100%",
                          height: "50px",
                        }}
                      />
                      <button
                        type="button"
                        className="btn-close position-absolute end-0 top-0 m-3"
                        onClick={() => setShowModal(false)}
                        aria-label="Close"
                        style={{ cursor: "pointer", zIndex: 1000 }}
                      ></button>
                    </div>

                    <div style={styles.welcomeDiv}>
                      <div className="d-block flex-column">
                        <img
                          src={require("../../assets/img/responsive_icon/loginMbanner.svg")}
                          alt="Background"
                          style={{
                            width: "81%",
                            height: "80%",
                            objectFit: "contain",
                          }}
                        />
                        <img
                          className="mt-2 mb-2"
                          src={require("../../assets/img/logo.svg")}
                          alt="Background"
                        />
                      </div>
                    </div>
                    <div className="px-4 position-relative">
                      {/* Logo */}

                      {/* Tabs */}
                      <div
                        style={{
                          display: `flex`,
                          border: "1px solid #ddd",
                          backgroundColor: "#f8f9fa",
                          borderRadius: "8px",
                          width: "100%",
                          overflow: "hidden",
                          padding: "4px",
                          marginBottom: "10px",
                        }}
                      >
                        <div
                          onClick={() => setActiveTab("agent")}
                          style={toggleStyle("agent")}
                        >
                          Agent Login
                        </div>
                      </div>

                      <form
                        action={agentActionUrl}
                        name="mainFormAgent"
                        id="mainFormAgent"
                        method="POST"
                      >
                        <div className="mb-3">
                          <input
                            style={{
                              fontSize: "11px",
                              color: "#A09999",
                              padding: "17px 15px",
                            }}
                            type="text"
                            value={agentUsername}
                            name={correctNamesAndIds.nameUserId}
                            onChange={(e) => {
                              setAgentUserName(e.target.value);
                            }}
                            className={getInputClass(
                              agentUsername,
                              errors.username
                            )}
                            placeholder="Username"
                          />
                        </div>
                        <div className="mb-3">
                          <input
                            style={{
                              fontSize: "11px",
                              color: "#A09999",
                              padding: "17px 15px",
                            }}
                            type="password"
                            value={agentPassword}
                            name={correctNamesAndIds.namePassword}
                            onChange={(e) => {
                              setAgentPassword(e.target.value);
                            }}
                            className={getInputClass(
                              agentPassword,
                              errors.password
                            )}
                            placeholder="Password"
                          />
                        </div>
                        <button
                          style={{ width: "100%", backgroundColor: "#0E72D6" }}
                          onClick={(e) => {
                            agentValidPost(e);
                            GA(
                              "Log_In ",
                              "User clicked on the agents login button inside pop up"
                            );
                          }}
                          className={`btn btn-mobile-primary-login ${checkDisabledButtonAgent(
                            isAgentDisabled
                          )}`}
                          type="submit"
                        >
                          Login
                        </button>
                        <div
                          className="text-center mt-3"
                          style={{ fontSize: "14px" }}
                        >
                          <a
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setIsForgotPasswordAgent(true);
                              setShowModal(false);
                            }}
                            className="text-primary text-decoration-none"
                          >
                            Reset Password
                          </a>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              {/* </div> */}
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
                <button className="btn btn-primary">Login</button>
              </div>
              {/* </div> */}
            </div>
            {/* Modal backdrop */}
            <div className="modal-backdrop fade show"></div>
          </div>
        )}
      {showSecondModal && (
        <div className="modal show fade d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              {/* <div className="modal-body custom-m odal-width"> */}
              <div className="modal show d-block" tabIndex="-1" role="dialog">
                <div
                  className="modal-dialog modal-xl modal-dialog-centered"
                  role="document"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <div
                    style={
                      responsiveStatus === "isDesktop"
                        ? styles.container
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? styles.container
                        : styles.container1
                    }
                    className="modal-content d-flex flex-row"
                  >
                    {/* Left Panel */}
                    <div
                      className="p-4 d-flex flex-column align-items-center justify-content-center"
                      style={{ width: "40%" }}
                    ></div>
                    <div className="d-flex justify-content-center mt-3"></div>
                    {/* Right Panel */}
                    <div
                      className="p-4 position-relative"
                      style={{ width: "60%" }}
                    >
                      <button
                        type="button"
                        className="btn-close position-absolute end-0 top-0 m-3"
                        onClick={() => setShowSecondModal(false)}
                        aria-label="Close"
                      ></button>

                      {/* Logo */}
                      <div className="text-center mb-3">
                        <img
                          src={require("../../assets/img/logo.png")}
                          alt="Car and Woman"
                          className="img-fluid"
                          style={{ height: "40px" }}
                        />
                        <br />
                        <small className="text-muted">
                          Automobile Insurance Company
                        </small>
                      </div>

                      {/* Tabs */}
                      <div
                        style={{
                          display: "flex",
                          border: "1px solid #ddd",
                          backgroundColor: "#f8f9fa",
                          borderRadius: "8px",
                          width: "100%",
                          overflow: "hidden",
                          padding: "4px",
                          marginBottom: "10px",
                        }}
                      >
                        <div
                          onClick={() => setActiveTab("customer")}
                          style={toggleStyle("customer")}
                        >
                          Customer Login
                        </div>
                      </div>

                      <form>
                        <div
                          className="mb-3"
                          style={{ display: "flex", gap: "20px" }}
                        >
                          <label
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              color: "#17252E",
                              fontSize: "14px",
                              fontWeight: 500,
                            }}
                          >
                            <input
                              type="radio"
                              value="agent"
                              checked={selectedRole === "agent"}
                              onChange={handleChange}
                            />
                            Agent Login
                          </label>

                          <label
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              color: "#17252E",
                              fontSize: "14px",
                              fontWeight: 500,
                            }}
                          >
                            <input
                              type="radio"
                              value="customer"
                              checked={selectedRole === "customer"}
                              onChange={handleChange}
                            />
                            Customer Login
                          </label>
                        </div>
                        <div className="mb-3">
                          <input
                            style={{ fontSize: "14px", color: "#A39B9B" }}
                            type="text"
                            className="form-control"
                            value={customerUsername}
                            placeholder="Username"
                            onChange={(e) => {
                              setCustomerUsername(e.target.value);
                            }}
                          />
                        </div>
                        <div className="mb-3">
                          <input
                            style={{ fontSize: "14px", color: "#A39B9B" }}
                            type="password"
                            value={customerPassword}
                            className="form-control"
                            onChange={(e) => {
                              setCustomerPassword(e.target.value);
                            }}
                            placeholder="Password"
                          />
                        </div>
                        <div className="mb-3">
                          <ul
                            style={{
                              display: `${
                                responsiveStatus === "isDesktop"
                                  ? "flex"
                                  : responsiveStatus === "isTablet" ||
                                    responsiveStatus === "isTabletLandscape"
                                  ? "flex"
                                  : "block"
                              }`,
                              fontSize: "6px",
                              color: "#000!important",
                              paddingLeft: "0px!important",
                              marginLeft: "0px!important",
                              whiteSpace: "nowrap",
                              gap: "16px",
                            }}
                          >
                            <li>
                              <Link
                                to="/uaichome/newuser/customer"
                                className="new-user"
                                style={{ color: "#000" }}
                                onClick={() => {
                                  setIsMenuOpened(false);
                                  GA(
                                    "NEW_USER_M",
                                    "User clicked on the NEW USER Customer in popup mobile"
                                  );
                                  dispatch({
                                    type: "SET_SELECTED_PAGE_TO_DISPLAY",
                                    payload: "NEW_USER",
                                  });
                                  setShowModal(false);
                                }}
                              >
                                Create An Account
                              </Link>
                            </li>

                            <li>
                              <a style={{ color: "#000" }} href="">
                                Policyholder Portal
                              </a>
                            </li>
                            <li>
                              <a
                                style={{ color: "#000" }}
                                href={`${selectCorrectUrls().claims_portal}`}
                              >
                                Continue As Guest
                              </a>
                            </li>
                          </ul>
                        </div>

                        <button
                          style={{ width: "100%", backgroundColor: "#0E72D6" }}
                          onClick={(e) => {
                            customerValidPost(e);
                            GA(
                              "Log_In ",
                              "User clicked on the agents login button inside pop up"
                            );
                          }}
                          className={checkDisabledButtonCustomer(
                            isCustomerDisabled
                          )}
                          type="submit"
                        >
                          Login
                        </button>
                        <div
                          className="text-center mt-3"
                          style={{ fontSize: "14px" }}
                        >
                          <a
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setIsForgotPasswordCustomer(true);
                              GA(
                                "FORGOT_PASSWORD_CUSTOMER_M",
                                "User clicked on the FORGOT_PASSWORD_CUSTOMER in popup mobile "
                              );
                            }}
                            className="text-primary text-decoration-none"
                          >
                            Reset Password
                          </a>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              {/* </div> */}
              {/* <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
                    <button className="btn btn-primary">Login</button>
                  </div> */}
            </div>
          </div>
          {/* Modal backdrop */}
          <div className="modal-backdrop fade show"></div>
        </div>
      )}
      {isForgotPasswordAgent && (
        <>
          <div
            className="modal show fade d-block second-modal"
            tabIndex="-1"
            role="dialog"
          >
            <div
              className="modal-dialog modal-dialog-centered"
              role="document"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <div className="modal-content" style={{ width: `"auto"` }}>
                {/* style={{ width: `${responsiveStatus ? "auto" : "100%"}` }} */}
                <div className="modal-header">
                  <h5 className="modal-title">Forgot Password</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setIsForgotPasswordAgent(false)}
                  ></button>
                </div>

                <div className="modal-body">
                  {/* <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content" style={{ border: "none" }}> */}
                  <p>Enter your Username:</p>
                  <form
                    style={{ width: "100%" }}
                    onSubmit={(e) => sendForgotPasswordEmail(e, "agent")}
                  >
                    <input
                      type="text"
                      placeholder="Username"
                      value={forgotPasswordAgent}
                      onChange={(e) => {
                        setForgotPasswordAgent(e.target.value);
                      }}
                      className="form-control mb-3"
                      required
                      autoFocus
                    />
                    <button
                      style={{
                        width: "100%",
                        backgroundColor: "#0E72D6",
                        border: "1px solid blue",
                        color: "#FFF",
                        padding: "8px",
                      }}
                      disabled={isForgotPasswordTimerAgent}
                      type="submit"
                    >
                      {isForgotPasswordTimerAgent
                        ? forgotPasswordTimerSecondsAgent
                        : "Submit"}
                    </button>
                  </form>
                  {/* </div>
            </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
      {isForgotPasswordCustomer && (
        <>
          <div
            className="modal show fade d-block second-modal"
            tabIndex="-1"
            role="dialog"
          >
            <div
              className="modal-dialog modal-dialog-centered"
              role="document"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <div
                className="modal-content"
                style={{
                  width: `${
                    responsiveStatus === "isDesktop"
                      ? "100%"
                      : responsiveStatus === "isTablet" ||
                        responsiveStatus === "isTabletLandscape"
                      ? "100%"
                      : "auto"
                  }`,
                }}
              >
                <div className="modal-header">
                  <h5 className="modal-title">Forgot password?</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setIsForgotPasswordCustomer(false)}
                  ></button>
                </div>

                <div className="modal-body">
                  {/* <div className="modal-dialog modal-sm modal-dialog-centered" style={{margin:"0px"}} role="document">
              <div className="modal-content d-flex flex-column p-1" style={{ border: "none" }}> */}
                  {/* <p>Enter your Username:</p> */}
                  <form
                    style={{ width: "100%" }}
                    onSubmit={(e) => sendForgotPasswordEmail(e, "customer")}
                  >
                    <input
                      type="text"
                      placeholder="Email"
                      value={forgotPasswordCustomer}
                      onChange={(e) =>
                        setForgotPasswordCustomer(e.target.value)
                      }
                      className="form-control mb-3"
                      required
                      autoFocus
                    />
                    <button
                      style={{
                        width: "100%",
                        backgroundColor: "#0E72D6",
                        border: "1px solid blue",
                        color: "#FFF",
                        padding: "8px",
                      }}
                      disabled={isForgotPasswordTimerCustomer}
                      type="submit"
                    >
                      {isForgotPasswordTimerCustomer
                        ? forgotPasswordTimerSecondsCustomer
                        : "Submit"}
                    </button>
                  </form>
                  {/* </div>
            </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </>
  );
}

const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    // minHeight: "400px",
    fontFamily: "Arial, sans-serif",
    backgroundImage: `url(${layout})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "75vh",
    maxHeight: "100vh",
    borderRadius: "15px",
  },
  container1: {
    display: "block",
    flexWrap: "wrap",
    width: "100%",
    // minHeight: "400px",
    fontFamily: "Arial, sans-serif",
    backgroundImage: `url(${layout})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "100vh",
    maxHeight: "100vh",
    borderRadius: "15px",
  },
  welcomeDiv: {
    display: "flex",
    flexWrap: "wrap",
    width: "77%",
    fontFamily: "Arial, sans-serif",
    // backgroundImage: "url(/static/media/welcomeLayoutImage.ffdd0519.svg)",
    // backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    // backgroundPosition: "center center",
    // height: "41vh",
    maxHeight: "100vh",
    borderRadius: "15px",
    zIndex: 0,
    margin: "auto",
    top: "-45",
    marginTop: "-135px",
    textAlign: "center",
  },
};
